import { useMemo } from "react";
import { Navigate } from "react-router";

import { Spinner } from "components/Spinner";
import { useAuthContext } from "context/AuthContext";

export const AuthRoute = ({ children }) => {
  const { isLoggedIn, isAppLoading } = useAuthContext();

  const isAuthenticated = useMemo(() => {
    return isLoggedIn;
  }, [isLoggedIn]);

  if (isAppLoading) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <Spinner size="xl" color="primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};
